import { CAST_AI } from '@cast/constants';

import {
  ControlWithDescription,
  InlineWithDescription,
} from 'components/form-layouts';

import { RffInput } from '@cast/shared-rff-ui';

export const ImageSection = () => (
  <InlineWithDescription
    description={
      <ControlWithDescription label="Image">
        Provide an image to be used when building {CAST_AI} provisioned node.
      </ControlWithDescription>
    }
    controls={
      <RffInput
        name="imageId"
        label="Image"
        inputProps={{
          placeholder:
            'e.g. projects/debian-cloud/global/images/debian-12-bookworm-v20240515',
        }}
        testId="image-id-input"
      />
    }
  />
);
